<template>
  <div class="return-policy">

    <app-header
        :position="'fixed'"
        :top="'0px'"
        :background="'#2F1F4C'"
        @clickBack="clickBack"
        @clickMenu="clickMenu"
    />

    <div class="return-policy__title">
      Правила заказа и возврата денежных средств
    </div>

    <div class="return-policy__descr">
        1. Цена и оплата<br>
        1.1. Неотъемлемым условием оформления Заказа на Сайте заказа поздравлений  является заключение Заказчиком с
          Владельцем сайта  договора на оказание Услуг, посредством выбора опции «Согласен» в соответствующем окне.<br>
        1.2. Цены на Услуги определяются Владельцем сайта, в одностороннем бесспорном порядке и
          указываются на Сайте заказа поздравлений.<br>
        1.3. Заказчику, оформляющему Заказ на Сайте заказа поздравлений, предоставляется
          возможность выбрать вариант оплаты в соответствии с предусмотренными способами.<br>
        1.4. В соответствии с условиями настоящего  Пользовательского соглашения чек
          в электронной форме направляется Заказчику по смс.
    </div>

    <div class="return-policy__descr">
        2. Возврат денежных средств<br>
        2.1 Возврат денежных средств в 100% объеме осуществляется в следующих случаях:<br>
        2.1.1 Заказчик отменил свой Заказ за 7 или более суток до выбранного им времени и даты при оформлении Заказа.<br>
        2.1.2 Заказчик не согласен с внесенными корректировками орфографических ошибок в соответствии с пунктом 2.2.1
        <router-link to="/offer">Пользовательского соглашения и оферты</router-link><br>
        2.2 Возврат денежных средств в размере 50% от стоимости Заказа возможен в следующих случаях:<br>
        2.2.1 Заказчик отменил свой Заказ в период от 7 до 3 суток до выбранного им даты и времени.<br>
        2.3. Возврат денежных средств не осуществляется в следующих случаях:<br>
        2.3.1 Заказчик нарушил  пункты 2.1.1 и 2.1.2  <router-link to="/offer">Пользовательского соглашения и оферты</router-link> при составлении Заказа.<br>
        2.3.1 Заказчик отменил Заказ менее, чем за 3 суток от выбранного им времени и даты.<br>
        2.4 Все претензии по услугам, Заказчики должны направлять по адресу электронной почты, указанной в разделе «контакты» сайта.
        В случае направления претензии по электронной почте, Заказчик  дает согласие на получение ответа на такую претензию также в электронном виде.
    </div>

    <transition
        name="fade-menu"
        appear
        mode="out-in"
    >
      <app-menu
          v-if="menu"
          idLogoMenu="header-component__menu"
          @clickLink="clickLink"
          @clickOutside="clickLink"
      />
    </transition>

    <transition
        name="fade-overlay"
        appear
        mode="out-in"
    >
      <app-overlay
          v-if="overlay"
      />
    </transition>

  </div>
</template>

<script>

const AppHeader = () => import('~/components/header.vue')
const AppMenu = () => import('~/components/menu.vue')
const AppOverlay = () => import('~/components/overlay.vue')

export default {
  data() {
    return {
      menu: false,
      overlay: false
    }
  },
  methods: {
    async clickBack() {
      this.$router.back()
    },
    async clickMenu() {
      this.overlay = true
      this.menu = true
    },
    async clickLink() {
      this.menu = false
      this.overlay = false
    }
  },
  components: {
    AppHeader,
    AppMenu,
    AppOverlay
  }
}
</script>

<style lang="less">

@import '~/assets/fonts/montserrat/Montserrat-Bold.less';

.return-policy {
  background-color: #2F1F4C;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 20px;
  user-select: text;
}

.return-policy__title {
  font-size: 20px;
  line-height: 20px;
  font-family: 'Montserrat-Bold';
  color: #FFFFFF;
  text-align: center;
  margin-top: 64px;
  margin-bottom: 32px;
  width: 100%;
  padding: 0px 20px;
  font-size: 20px;
}

@import '~/assets/fonts/montserrat/Montserrat-Light.less';

.return-policy__descr {
  max-width: 1000px;
  font-size: 16px;
  font-family: 'Montserrat-Light';
  padding: 0px 30px;
  color: #FFFFFF;
  line-height: 22px;
  margin-bottom: 20px;
}

.return-policy__descr a {
  color: #00bcd4;
  cursor: pointer;
  text-decoration: none;
}
</style>